import { render, staticRenderFns } from "./AccountSetup.vue?vue&type=template&id=100b241f&scoped=true&"
import script from "./AccountSetup.vue?vue&type=script&lang=ts&"
export * from "./AccountSetup.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSetup.vue?vue&type=style&index=0&id=100b241f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100b241f",
  null
  
)

export default component.exports